(function filmStripHover(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.Event) {
    return;
  }

  const previousFilmStripHover = global.NewHomeSource.FilmStripHover;
  const containerElement = global.document.querySelector('[data-full-image-viewer-role="filmstrip"]');
  const hoverableCollections = ['FloorPlan'];
  const hoverableCssClass = 'hoverable';

  /**
  * @private
  * render: renders the film strip.
  *
  * @param {object} data information that is needed to render the film strip.
  */
  function render(data) {
    if (hoverableCollections.indexOf(data.Name) >= 0) {
      containerElement.classList.add(hoverableCssClass);
    } else {
      containerElement.classList.remove(hoverableCssClass);
    }
  }
  /**
   * @constructs NewHomeSource.FilmStripHover
   */
  function FilmStripHover() {
  }

  /**
  * @public
  * update: this method will be called by the Event Bus when the data is updated.
  *
  * @param {object} data information that was changed.
  */
  FilmStripHover.update = function update(data) {
    requestAnimationFrame(render.bind(this, data));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FilmStripHover to the previous script.
   */
  FilmStripHover.noConflict = function noConflict() {
    global.NewHomeSource.FilmStripHover = previousFilmStripHover;
    return FilmStripHover;
  };

  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', FilmStripHover);
  global.NewHomeSource.FilmStripHover = FilmStripHover;
}(window));
